import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRelatedBlogs } from '../features/relatedBlogs.js/relatedBlogsSlice';
import Error from './Error';
import Loader from './Loader';
import RelatedBlogCard from './RelatedBlogCard';

const RelatedBlogs = ({ id, tags }) => {
  const dispatch = useDispatch();

  const { relatedBlogs, isLoading, isError, error } = useSelector(
    (state) => state.relatedBlogs
  );

  useEffect(() => {
    dispatch(fetchRelatedBlogs({ id, tags }));
  }, [dispatch, id, tags]);

  // decide what to render
  let content = null;

  if (isLoading) content = <Loader />;

  if (!isLoading && isError) content = <Error msg={error} />;

  if (!isError && !isLoading && relatedBlogs?.length === 0) {
    content = <div className="col-span-12">No Related Blogs Found!</div>;
  }

  if (!isError && !isLoading && relatedBlogs?.length > 0) {
    content = relatedBlogs.map((blog) => (
      <RelatedBlogCard key={blog.id} blog={blog} />
    ));
  }

  return (
    <aside>
      <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">
        Related Posts
      </h4>
      <div className="space-y-4 related-post-container">{content}</div>
    </aside>
  );
};

export default RelatedBlogs;
